import { useRef } from 'react';
import type { HighwayMaintenanceFeePenaltyTicketSummary } from '#/components/ui/tickets/highway-maintenance-fee-penalty/model';

export type ConfirmPaymentOnBehalfDialogRef = {
  confirm: (
    ticket: HighwayMaintenanceFeePenaltyTicketSummary,
  ) => Promise<boolean>;
};

export const useConfirmPaymentOnBehalfDialog = () => {
  const modalRef = useRef<ConfirmPaymentOnBehalfDialogRef>(null);
  const confirm = (ticket: HighwayMaintenanceFeePenaltyTicketSummary) =>
    modalRef.current?.confirm(ticket);
  return { props: { modalRef }, confirm };
};
